module.exports = __webpack_public_path__ + "static/media/guide_img1_6_m.159236d1.png";